<template>
  <PartnerContainer
    :partners-logo="peppolLogo"
    :loading="loading"
    :scrollable="scrollable"
    :background-colored="backgroundColored"
    tint="peppol"
    :size="size"
    :class="$attrs.class"
  >
    <template v-if="$slots['top-left-cta']" #top-left-cta>
      <slot name="top-left-cta" />
    </template>
    <template #default>
      <slot name="default" />
    </template>
    <template v-if="$slots['header']" #header>
      <slot name="header" />
    </template>
    <template v-if="$slots['top-right-cta']" #top-right-cta>
      <slot name="top-right-cta" />
    </template>
    <template v-if="$slots['bottom-right-cta']" #bottom-right-cta>
      <slot name="bottom-right-cta" />
    </template>
    <template v-if="$slots['bottom-left-cta']" #bottom-left-cta>
      <slot name="bottom-left-cta" />
    </template>
  </PartnerContainer>
</template>

<script>
import peppolLogo from '@/assets/images/partners/peppol.svg'
import PartnerContainer from '@c/Partner/PartnerContainer.vue'

export default {
  name: 'PeppolContainer',
  components: { PartnerContainer },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    scrollable: {
      type: Boolean,
      require: false,
      default: false
    },
    backgroundColored: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  computed: {
    peppolLogo() {
      return peppolLogo
    }
  }
}
</script>
